import React from "react";
import { Wifi, WifiOff } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface ConnectionQualityIndicatorProps {
  quality: 'excellent' | 'good' | 'poor' | 'unknown';
}

export const ConnectionQualityIndicator: React.FC<ConnectionQualityIndicatorProps> = ({
  quality,
}) => {
  const getQualityConfig = () => {
    switch (quality) {
      case 'excellent':
        return {
          color: 'bg-green-600 text-white',
          bars: 3,
          label: 'Excellent',
          icon: <Wifi className="h-3 w-3" />,
        };
      case 'good':
        return {
          color: 'bg-yellow-500 text-white',
          bars: 2,
          label: 'Good',
          icon: <Wifi className="h-3 w-3" />,
        };
      case 'poor':
        return {
          color: 'bg-orange-600 text-white animate-pulse',
          bars: 1,
          label: 'Poor',
          icon: <Wifi className="h-3 w-3" />,
        };
      case 'unknown':
      default:
        return {
          color: 'bg-gray-600 text-white',
          bars: 0,
          label: 'Unknown',
          icon: <WifiOff className="h-3 w-3" />,
        };
    }
  };

  const config = getQualityConfig();

  // Render signal bars
  const renderSignalBars = () => {
    const bars = [];
    for (let i = 0; i < 3; i++) {
      bars.push(
        <div
          key={i}
          className={`w-1 rounded-sm ${
            i < config.bars 
              ? quality === 'excellent' 
                ? 'bg-green-400' 
                : quality === 'good'
                ? 'bg-yellow-400'
                : 'bg-orange-400'
              : 'bg-gray-600'
          }`}
          style={{ height: `${4 + i * 2}px` }}
        />
      );
    }
    return bars;
  };

  return (
    <div className="flex items-center gap-2">
      <Badge variant="outline" className={`${config.color} border-none flex items-center gap-1 text-xs`}>
        <div className="flex items-end gap-0.5 h-3">
          {config.bars > 0 ? renderSignalBars() : config.icon}
        </div>
        <span className="hidden sm:inline">{config.label}</span>
      </Badge>
    </div>
  );
};